import React, { useState } from "react";
import SEO from "../components/SEO";

const FAQ = () => {
  const faqs = [
    {
      q: "What types of hat patches do you offer?",
      a: "We offer embroidered, woven, PVC, leather, and printed patches for hats. All patches are fully customizable in size, shape, color, and backing."
    },
    {
      q: "Can I order personalized hat patches in small quantities?",
      a: "Yes! We accept both small and bulk orders. Whether you need a single patch or thousands, we’ve got you covered."
    },
    {
      q: "How long does production take?",
      a: "Production usually takes 7–10 business days after design approval. Rush options may be available upon request."
    },
    {
      q: "Do you provide design assistance?",
      a: "Absolutely. Our expert designers will refine or create your patch design at no extra cost."
    },
    {
      q: "What backings are available for hat patches?",
      a: "We offer iron-on, sew-on, Velcro, adhesive, and heat-seal backings depending on your needs."
    },
    {
      q: "Can I see a sample before full production?",
      a: "Yes. We provide a digital proof for approval before production begins."
    },
    {
      q: "What if there is an issue with my order?",
      a: "If there is a production error, submit an Order Issue Form within 45 days of delivery and we’ll make it right."
    },
    {
      q: "Do you ship internationally?",
      a: "Currently, we primarily serve customers in the United States. For international shipping, please contact our support team."
    }
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <SEO
        title='FAQ'
        description='Shirts Patches'
        keywords='Shirts Patches'
      />
      <div className="bg-gradient-to-b from-[#437d6a]/10 to-white min-h-screen py-20">
        <div className="container mx-auto px-4 max-w-5xl">

          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-extrabold text-[#437d6a]">
              Frequently Asked Questions
            </h1>
            <p className="mt-4 text-gray-600 text-lg max-w-3xl mx-auto">
              Find answers to common questions about <strong>Personalised Patches for Hats</strong>.
            </p>
          </div>

          {/* Accordion */}
          <div className="space-y-4">
            {faqs.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg overflow-hidden"
              >
                <button
                  onClick={() => toggle(index)}
                  className={`w-full flex justify-between items-center px-6 py-4 text-left text-lg font-semibold text-gray-900 
                            hover:bg-[#437d6a]/10 transition`}
                >
                  <span>{item.q}</span>
                  <span className={`text-2xl text-[#437d6a] transform transition-transform duration-300 ${openIndex === index ? "rotate-45" : ""}`}>
                    +
                  </span>
                </button>

                {/* Answer */}
                <div
                  className={`px-6 overflow-hidden transition-all duration-300 ${openIndex === index ? "max-h-96 py-4" : "max-h-0"}`}
                >
                  <p className="text-gray-700 leading-relaxed">{item.a}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-20 text-center bg-[#437d6a]/10 rounded-3xl p-10">
            <h2 className="text-3xl font-bold text-[#437d6a] mb-4">
              Still Have Questions?
            </h2>
            <p className="text-gray-700 mb-6">
              Our support team is happy to help you with anything you need.
            </p>

            <a
              href="/contact-us"
              className="inline-block bg-[#437d6a] text-white px-10 py-4 rounded-xl font-semibold hover:bg-[#356657] transition"
            >
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
